import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIAvatarComponent } from './ui-avatar.component';

@NgModule({
  declarations: [
    UIAvatarComponent
  ],
  exports: [
    UIAvatarComponent
  ],
  imports: [
    CommonModule
  ]
})
export class UIAvatarModule { }
